<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mJa6EV/tc-custom/9781035816996.jpg?1725565603027" alt="This image is the cover for the book From My Heart to Yours"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">From My Heart to Yours
      </h1>
      <p class="bookDescription body article font2">
        <p>Embark on a stirring odyssey through rhythm and rhyme, where every verse resonates with profound reflections and deep insight. Experience the rhythmic cadence of life. Be captured by the enchantment of words. Unveil just a little something of God’s design for life. Every poem in this collection is infused with a deeply Christian message, offering solace and encouragement. Pause, reflect, and let the words seep into your soul. Will this book captivate you so deeply that setting it aside becomes a challenge? Embark on this voyage, and may it bless your own life’s journey.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vernon Postmus
      </h2>
      
      <p class="authorDescription body article">Who is Vernon? Can you find him? Maybe he is with his family, fishing or bushwalking? Or just enjoying the great outdoors? No, I can’t seem to find him there! Shhh… Over there, I just spotted him, tucked away in that quiet space… He looks occupied, wrestling with words, as they tumble around him. There’s determination in his eyes, as he marshals them into line. It appears that a subject has caught his attention! Maybe it’s some marvel of creation that has a story to tell. Perhaps it is a word or a subject that he is pondering on. Either way, he appears determined to keep the message clear. There he goes, gently beating the words into a rhythm. And massaging the verse into rhyme. Come, take a look and see…</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?07fdc5c3